<template>
  <div class="text-white overflow-y-auto" v-if="vg_selectedLocation.id">
    <div :class="'p-3 flex content-main ' + (action.component ? ' half-it gap-5' : 'gap-5')">
      <div class="custom-full">
        <div class="rounded-lg lg:pb-5">
          <div class="flex justify-between mt-2 h-[40px]">
            <h2 class="text-white font-semibold text-[24px]">Payment Terminals</h2>
            <!-- <button @click="addUpdate({ component: 'Add', data: {}})" v-if="!action.component">
              <span class="text-white hover:bg-theme-darkgreen bg-green-500 px-3 text-3xl border-0 rounded-md cursor-pointer">+</span>
            </button> -->
          </div>
          <List :selectedItemCallback="selectedItem" :addComponent="openAddComponent" :clearComponent="clearComponent" :iscomponentactive="action.component ? true : false"/>
        </div>
      </div>

       <div :class="'w-full hidden-component'" v-if="action.component" >
        <component :is="action.component" :item="action.data" :clearComponent="clearComponent"></component>
      </div>

    </div>
  </div>

  <div v-else class="flex lg:flex-row  items-center justify-center flex-col bg-[#2B2C32] rounded-xl">
            
      <div class="w-full">
        <div class="bg-[#2B2C32] rounded-lg px-8 py-[16px]">
          <p  class="text-center text-theme-red">Please select a location.</p>
        </div>
      </div>
    
  </div>


</template>


<script lang="ts">
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions, mapMutations } from "vuex";
import Nav from '@/views/Location/Integrations/Nav.vue';
import List from '@/views/Location/Integrations/PaymentTerminals/List.vue';
import Add from '@/views/Location/Integrations/PaymentTerminals/Add.vue';
import Update from '@/views/Location/Integrations/PaymentTerminals/Update.vue';

export default defineComponent({
  name: "LocationDevicesPos",
  components: {
   Nav,
   List,
   Add,
   Update
  },

  setup() {
    const action = ref<object>({
      component: '',
      data: {},
    });
    return {
      action,
    };
  },

   watch: {
    'vg_selectedLocation'(val) {
      // if location selected clear component
      this.clearComponent();
    },
  },

  computed: {
    ...mapGetters({
     vg_selectedLocation: 'location/selected'
    }),
  },

  mounted() {
   
  },

  beforeDestroy() {
   
  },
 
  methods: {
    /**
     * Clear action
     */
    clearComponent() {
      this.action = {
        component: '',
        data: {},
      };
    },

    openAddComponent() {
      this.addUpdate({
        component: 'Add', 
        data: {}
      })
    },

    /**
     * Change add / update component
     */
    addUpdate(val: any) {
      this.action = val;
    },

    /**
     * Capture selected item
     */
    selectedItem(item) {
      this.addUpdate({
        component: 'Update', 
        data: item
      })
    },

    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});

</script>

